interface Props {
  visible: boolean;
}

/**
 * ON AIR badge — positioned center of the header by the parent.
 * Only the red dot pulses (radar-ping box-shadow at 1.5s).
 * The badge container and text are static.
 */
export function OnAirBadge({ visible }: Props) {
  if (!visible) return null;
  return (
    <div className="inline-flex items-center gap-4 rounded-lg border-2 border-red-600/60 bg-red-600/15 px-7 py-3">
      <span className="h-4 w-4 rounded-full bg-red-600 animate-pulse-dot" />
      <span className="text-2xl font-bold tracking-[3px] text-red-500 md:text-3xl">
        ON AIR
      </span>
    </div>
  );
}
